export default (value) => typeof value === "number";
